module.exports = __webpack_public_path__ + "static/img/map.8563b15a.png";